import { useState } from "react"

import { Collapse, Flex, Typography } from "antd"

import Icon from "../../Icon"

import styles from "./FaqAccordion.module.less"

const { Text } = Typography

const FaqAccordion = ({ items = [] }) => {
  const [activeKey, setActiveKey] = useState(null)

  const togglePanel = (id) => (e) => {
    if (["BUTTON", "A", "INPUT", "TEXTAREA"].includes(e.target.tagName)) return
    setActiveKey((prev) => (prev === id ? null : id))
  }

  return (
    <Flex vertical>
      {items.map((item, id) => (
        <div
          onClick={togglePanel(id)}
          key={id}
          className={styles.itemContainer}
          style={{ marginTop: activeKey === id ? "14px" : "0" }}
          data-testid={`faq-accordion-item-${id}`}
        >
          <Collapse
            ghost
            expandIconPosition="end"
            accordion
            activeKey={activeKey}
            expandIcon={({ isActive }) => (
              <Icon
                type="chevron_down"
                style={{
                  transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"
                }}
              />
            )}
            items={[
              {
                key: id,
                label: (
                  <Text className={styles.title} data-testid={`faq-accordion-item-title-${id}`}>
                    {item.title}
                  </Text>
                ),
                className: styles.faq,
                classNames: { header: styles.faq, body: styles.faq },
                children: <div data-testid={`faq-accordion-item-body-${id}`}>{item.text}</div>
              }
            ]}
          />
        </div>
      ))}
    </Flex>
  )
}

export default FaqAccordion
